import Tools from './../components/tools';
import { tns } from './../../../node_modules/tiny-slider/src/tiny-slider';

export default class Home {
    constructor() {
        // Home

        this.scrollBtn();
        this.positionning();
        this.sliders();
    }

    scrollBtn() {
        const btn = document.querySelector('.header__scroll');
        const elt = document.querySelector('.section.introduction');

        if (btn && elt) {
            btn.addEventListener('click', () => {
                window.scrollTo({
                    top: Tools.offset(elt).top - 20,
                    left: 0,
                    behavior: 'smooth',
                });
            });
        }
    }

    positionning() {
        const elt = document.querySelector('.section.introduction');
        const header = document.querySelector('.header');
        if (elt && header) {
            let offset = 0;
            if(window.innerWidth > 1023) {
                offset = window.innerHeight;
            } else {
                if (document.body.classList.contains('admin-bar')) {
                    offset = 32;
                }
                offset += document.querySelector('.nav').offsetHeight;
                offset += header.offsetHeight;
            }
            elt.style.marginTop = `${offset}px`;
            header.classList.add('js-position');
        }
    }

    sliders() {
        const elts = document.querySelectorAll('.project__sliderContainer');
        if (elts.length > 0) {
            elts.forEach((elt) => {
                tns({
                    container: elt,
                    items: 1,
                    slideBy: 'page',
                    loop: true,
                    autoplay: false,
                    nav: false,
                    speed: 650,
                    controlsPosition: 'bottom',
                    controlsText: ['<span class="sr-only">Précédent</span><svg xmlns="http://www.w3.org/2000/svg" width="24.56" height="8.751" viewBox="0 0 24.56 8.751"><path d="M8.584 19.807a.6.6 0 0 0-.839 0L4.97 22.569V.588a.593.593 0 0 0-1.185 0v21.981L1.009 19.8a.6.6 0 0 0-.839 0 .59.59 0 0 0 0 .834l3.783 3.755a.665.665 0 0 0 .187.123.566.566 0 0 0 .228.046.594.594 0 0 0 .415-.169l3.787-3.753a.581.581 0 0 0 .014-.829z" transform="rotate(-90 4.376 4.375)" fill="currentColor" /></svg>', '<span class="sr-only">Suivant</span><svg xmlns="http://www.w3.org/2000/svg" width="24.56" height="8.751" viewBox="0 0 24.56 8.751"><path d="M8.584 19.807a.6.6 0 0 0-.839 0L4.97 22.569V.588a.593.593 0 0 0-1.185 0v21.981L1.009 19.8a.6.6 0 0 0-.839 0 .59.59 0 0 0 0 .834l3.783 3.755a.665.665 0 0 0 .187.123.566.566 0 0 0 .228.046.594.594 0 0 0 .415-.169l3.787-3.753a.581.581 0 0 0 .014-.829z" transform="rotate(-90 4.376 4.375)" fill="currentColor" /></svg>'],
                });
            });
        }
    }
}